import React, {lazy, Suspense} from 'react';
import {useHelp} from '../context/HelpContext';

// The help overlay draws nothing until help mode is switched on, so it - and the help text it
// reads (content/helpContent) - is only loaded then, not with every page.
const HelpOverlay = lazy(() => import('./HelpOverlay'));

export default function LazyHelpOverlay() {
    const {helpModeOn} = useHelp();
    if (!helpModeOn) return null;
    return <Suspense fallback={null}><HelpOverlay/></Suspense>;
}
